import React from 'react';

/**
 * High-fidelity Brand badge icon with heart center and ribbon tails.
 * Replaces the placeholder brand icon with a clean outline design
 * matching the user's reference image exactly.
 */
const BrandIcon = ({ size = 32, color = '#4776E6' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {/* Scalloped outer seal (12 points) */}
        <path d="M32 8
                 c1.4 0 2.5 1.1 3.6 1.9 1 .8 2.2 1.3 3.5 1.3 1.4 0 2.5-1.1 3.6-1.9.9-.7 2.2-.7 3.1 0 .9.7 1.3 1.9 1.3 3.1 0 1.3.5 2.5 1.3 3.5.8 1.1 1.9 2.2 1.9 3.6 0 1.4-1.1 2.5-1.9 3.6-.8 1-1.3 2.2-1.3 3.5 0 1.4 1.1 2.5 1.9 3.6.7.9.7 2.2 0 3.1-.7.9-1.9 1.3-3.1 1.3-1.3 0-2.5.5-3.5 1.3-1.1.8-2.2 1.9-3.6 1.9-1.4 0-2.5-1.1-3.6-1.9-1-.8-2.2-1.3-3.5-1.3-1.4 0-2.5 1.1-3.6 1.9-.9.7-2.2.7-3.1 0-.9-.7-1.3-1.9-1.3-3.1 0-1.3-.5-2.5-1.2-3.5-.8-1.1-1.9-2.2-1.9-3.6 0-1.4 1.1-2.5 1.9-3.6.8-1 1.3-2.2 1.3-3.5 0-1.4-1.1-2.5-1.9-3.6-.7-.9-.7-2.2 0-3.1.7-.9 1.9-1.3 3.1-1.3 1.3 0 2.5-.5 3.5-1.3 1.1-.8 2.2-1.9 3.6-1.9z" />

        {/* Inner circle of the badge */}
        <circle cx="32" cy="25" r="11" />

        {/* Outline heart in the center of the circle */}
        <path d="M32 29.5
                 c-.8-.8-3.5-3.3-3.5-5.3 0-1.6 1.2-2.8 2.8-2.8 1 0 1.8.5 2.2 1.3.4-.8 1.2-1.3 2.2-1.3 1.6 0 2.8 1.2 2.8 2.8 0 2-2.7 4.5-3.5 5.3z" />

        {/* Ribbon tails behind the badge */}
        {/* Left ribbon */}
        <path d="M25 35 l-5 17 6-3 6 3-2-11" />
        {/* Right ribbon */}
        <path d="M37 35 l5 18-6-3-6 3 2-11" />
    </svg>
);

export default BrandIcon;
